<template>
  <v-container id="attendance-list">
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>Reuniões de Acompanhamento</v-col>
      <!-- <v-col
        class="text-right"
      >
        <v-btn
          v-if="(isAdmin)"
          outlined
          color="success"
          class="ml-3"
          @click="acompanhamentoFinalizacao"
        >
          Acompanhamento de Finalização
        </v-btn>
      </v-col> -->
      <v-col class="text-right">
        <app-modal-insert-attendance
          v-if="groupsConfig.novoAcompanhamento && config.novoAcompanhamento"
          :dialog="false"
        >
        </app-modal-insert-attendance>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="acompanhamentos"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <a
              :href="
                './#/cidade/' +
                payload.municipioId +
                '/acompanhamento/obter/' +
                item.acompanhamentoId
              "
              >{{
                item.nome === "Diagnóstico" && isSala
                  ? "Acompanhamento Geral"
                  : item.nome
              }}</a
            >
          </template>

          <template v-slot:item.criacao="{ item }">
            {{ item.criacao | moment("DD/MM/YYYY") }}
          </template>

          <template v-slot:item.finalizado="{ item }">
            <span v-if="item.finalizado === true">
              <v-icon color="primary"> mdi-check-circle-outline </v-icon>
            </span>

            <span v-if="item.finalizado === false">
              <v-icon color="error"> mdi-cancel </v-icon>
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <a
              :href="
                './#/cidade/' +
                payload.municipioId +
                '/pmd/' +
                item.acompanhamentoId
              "
              >Plano de Ação</a
            >
          </template>

          <template slot="no-data">
            <span> Nenhum acompanhamento retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertAttendance from "./ModalInsert";
import { attendanceAPI } from "@/modules/attendance";
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";

export default {
  components: {
    AppModalInsertAttendance,
    AppCityHeader,
  },
  data() {
    return {
      headers: [
        { text: "Título", value: "nome" },
        { text: "Criado em", value: "criacao" },
        { text: "Status", value: "finalizado" },
        { text: "Sim", value: "sim" },
        { text: "Não", value: "nao" },
        { text: "Pontos", value: "pontos" },
        { text: "Ações", value: "acoes" },
      ],
      user: JSON.parse(localStorage.getItem("user")),
      payload: {
        municipioId: this.$route.params.id,
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      acompanhamentos: [
        {
          municipio: {
            diagnostico: false,
          },
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio",
    ]),
    listAttendances() {
      this.setLoading(true);

      attendanceAPI
        .list(this.$route.params.id)
        .then((resp) => {
          this.acompanhamentos = resp.data;

          if (!this.user.grupo.verTodosEixos) {
            this.acompanhamentos = this.acompanhamentos.filter(
              (item) =>
                this.user.permissoes.some((per) => {
                  return (
                    item.nome.indexOf(per.eixo.nome) > -1 &&
                    per.municipioId == this.$route.params.id
                  );
                }) || item.nome === "Diagnóstico"
            );
          }

          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao listar acompanhamentos: ", err);
          this.setLoading(false);
          this.$notification.error("Erro ao obter acompanhamentos");
        });
    },
    acompanhamentoFinalizacao() {
      this.setLoading(true);
      attendanceAPI
        .finalizacao(this.$route.params.id)
        .then((resp) => {
          this.listAttendances();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error(
            "Erro ao gerar acompanhamento de finalização"
          );
        });
    },
  },
  mounted() {
    this.listAttendances();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "isSala",
    ]),
  },
};
</script>
